import React from "react";

export type AuthStatusVariant = "info" | "error" | "success";

interface AuthStatusBannerProps {
  message: string;
  variant?: AuthStatusVariant;
}

const variantStyles: Record<AuthStatusVariant, string> = {
  info: "text-fg-medium",
  error: "text-error",
  success: "text-success",
};

export const AuthStatusBanner: React.FC<AuthStatusBannerProps> = ({
  message,
  variant = "info",
}) => {
  if (!message) return null;

  return (
    <p className={`text-center text-sm ${variantStyles[variant]}`}>{message}</p>
  );
};
